<mat-dialog-content>
  <h3 class="mb-3">
    {{
      isBuying
        ? ("HEADER.CONTEXT.SELECT_CONTEXT_BUYING" | translate)
        : ("HEADER.CONTEXT.SELECT_CONTEXT_SELLING" | translate)
    }}
  </h3>
  <p class="mt-0">
    {{
      isBuying
        ? ("HEADER.CONTEXT.SELECT_CONTEXT_CONTENT_BUYING" | translate)
        : ("HEADER.CONTEXT.SELECT_CONTEXT_CONTENT_SELLING" | translate)
    }}
  </p>

  <mat-button-toggle-group
    class="d-flex flex-column gap-3 mb-4"
    (change)="selectedContextChanged($event)"
  >
    <mat-button-toggle
      *ngFor="let context of choosableContexts"
      class="d-flex"
      [value]="context"
      [ngClass]="{
        selected:
          context.merchantType === selectedOption.merchantType &&
          context.siteId === selectedOption.siteId
      }"
    >
      <mat-chip #chip class="mint-chip" *ngIf="context.merchantType">
        {{ "MERCHANT.TYPE_CATEGORIZED." + context.merchantType | translate }}
      </mat-chip>
      <div class="telep-data" [ngStyle]="{ left: maxWidth + 24 + 'px' }">
        <span class="name">{{ context.siteName }}</span>
        <span class="address"
          >{{ context.address.city }}
          {{ context.address.streetName }}
          {{ context.address.streetType }}
          {{ context.address.number }}
        </span>
      </div>
    </mat-button-toggle>
  </mat-button-toggle-group>

  <a
    mat-raised-button
    class="d-flex gap-2 align-items-center"
    [routerLink]="'/account/merchant/sites/create'"
    (click)="dialogRef.close({ selected: true })"
  >
    <mat-icon>add</mat-icon>Új telephely hozzáadása
  </a>
</mat-dialog-content>
